export default __webpack_public_path__ + "static/media/button_point-on.45153a4e.svg";